/*
 * @Description:
 * @Autor: lichao
 * @Date: 2022-01-05 09:54:38
 * @LastEditors: lichao
 * @LastEditTime: 2022-01-05 16:12:10
 */
import { useLocation } from 'react-router'
import {useEffect} from "react";
import { renderRoutes } from "./router/index";
import { Switch, Redirect } from "react-router-dom";
import routes from "./router/routes";
import Menu from "./components/Menu";
import SiteMapFooter from "./components/SiteMapFooter";
import "./App.css";

const CAPTCHA_VERIFIED_PATH = "captcha_verified_path";

/** 验证码开启时间段：每天 20:00 至次日 08:30（本地时间） */
function isCaptchaTimeWindow() {
  const now = new Date();
  const h = now.getHours();
  const m = now.getMinutes();
  if (h >= 20) return true; // 20:00 - 23:59
  if (h < 8) return true;   // 00:00 - 07:59
  if (h === 8 && m <= 30) return true; // 08:00 - 08:30
  return false;
}

function App() {
    useEffect(()=> {
        //友盟统计数据，单页面应用需要监听路由跳转
        const hm=document.createElement('script');
        hm.src="https://s4.cnzz.com/z_stat.php?id=1280778114&web_id=1280778114";
        const s=document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(hm,s)
    }, [useLocation()])
  const location = useLocation();
  console.log(location)
  const pathname = location.pathname;
   // 路由守卫：仅在时间段内生效；首次进入或路由变化时，未在验证码页且当前路径未在当次验证通过范围内，则先跳验证码页
   const verifiedPath =
   typeof sessionStorage !== "undefined"
     ? sessionStorage.getItem(CAPTCHA_VERIFIED_PATH)
     : null;
 const needVerify =
   isCaptchaTimeWindow() &&
   pathname !== "/verify" &&
   pathname !== "/404" &&
   pathname !== verifiedPath;

 if (needVerify) {
   return (
     <Redirect
       to={{
         pathname: "/verify",
         state: { from: pathname },
       }}
     />
   );
 }


  return (
    <div className="App">
      {
        location.pathname === '/invbase/introduce' || location.pathname === '/invbase/AIandFinance' || location.pathname.includes('download')?(
          <Switch>{renderRoutes(routes)}</Switch>
        ) : (
          <div>
            <Menu></Menu>
            <Switch>{renderRoutes(routes)}</Switch>
            <SiteMapFooter></SiteMapFooter>
          </div>
        )
      }
    </div>

  );
}

export default App;
